import { c as _c } from "react/compiler-runtime";
import { Checkbox } from '@/components/ui/checkbox';
type AllVariablesToggleProps = {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
};
const AllVariablesToggle = t0 => {
  const $ = _c(5);
  const {
    checked,
    onCheckedChange
  } = t0;
  let t1;
  if ($[0] !== onCheckedChange) {
    t1 = details => onCheckedChange(details.checked === true);
    $[0] = onCheckedChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== checked || $[3] !== t1) {
    t2 = <Checkbox aria-label="show-all-variables" checked={checked} size="sm" whiteSpace="nowrap" onCheckedChange={t1}>All</Checkbox>;
    $[2] = checked;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export default AllVariablesToggle;